module.exports = __webpack_public_path__ + "img/icon.0ba4c3d9.jpg";